module.exports = {"id":"176894","name":"Mossoró","rating":"76","photo":"./data/images/photos/1/176894.png","club":{"name":"Medipol Başakşehir","logo":"./data/images/clubs/MedipolBasaksehir.png"},"positions":["MOC","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Mossoro0.json
// module id = 3086
// module chunks = 0